import { Base_URL } from '../../Client/apiURL';

export async function plannerRequest(path = '', { method = 'GET', body, signal } = {}) {
  const response = await fetch(`${Base_URL}/app/users/ielts-planner${path}`, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    signal,
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const data = await response.json();
  if (!response.ok || data?.responseCode < 200 || data?.responseCode >= 300 || !data?.responseCode) {
    throw Object.assign(new Error(data?.message || 'Unable to load the study planner. Please retry.'), { status: data?.responseCode || response.status });
  }
  return data.response;
}
